// ignore-string-externalization
import { LazyAccessRoutes } from "../../features/Team/Onboarding/LazyAccessRoutes";
export var accessRouteConfig = {
    path: "/access",
    body: LazyAccessRoutes,
    allowUnauthenticated: false
};
